import { createContext, useContext, useEffect, useState } from "react";
import { getEquipmentMetadata, getWorkoutMetadata } from "api/exercisePlan";
import { getAccessToken } from "./OAuth/authService";

export const MetaContext = createContext();

export const useMeta = () => useContext(MetaContext);

export const MetaProvider = ({ children }) => {
  const [dynamicOptions, setDynamicOptions] = useState({
    workoutsCategories: [],
    difficultiesLevel: [],
    equipmentCategories: [],
  });
  const fetchDynamicOptions = async () => {
    try {
      const [workoutMeta, equipmentMeta] = await Promise.all([
        getWorkoutMetadata(),
        getEquipmentMetadata(),
      ]);

      const newDynamicOptions = {
        workoutsCategories: workoutMeta.categories,
        difficultiesLevel: workoutMeta.difficulties,
        equipmentCategories: equipmentMeta.categories,
      };

      setDynamicOptions(newDynamicOptions);

      return newDynamicOptions;
    } catch (error) {
      console.error("Error fetching dynamic options:", error);
    //   toast.error("Failed to load exercise options.");
      return dynamicOptions;
    }
  };

  useEffect(() => {
    if(getAccessToken()){
      fetchDynamicOptions();
    }
  }, [getAccessToken()]);
  return (
    <MetaContext.Provider value={{ dynamicOptions, setDynamicOptions }}>
      {children}
    </MetaContext.Provider>
  );
};
